import { render } from "./TypeCard.vue?vue&type=template&id=51b58651&scoped=true"
import script from "./TypeCard.vue?vue&type=script&lang=js"
export * from "./TypeCard.vue?vue&type=script&lang=js"

import "./TypeCard.vue?vue&type=style&index=0&id=51b58651&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b58651"]])

export default __exports__